export default __webpack_public_path__ + "static/media/no-data-labor-icon.46c34deb.svg";